import { render, staticRenderFns } from "./CRUDAgenciasEmprego.vue?vue&type=template&id=72857f91&"
import script from "./CRUDAgenciasEmprego.vue?vue&type=script&lang=js&"
export * from "./CRUDAgenciasEmprego.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports